<div class="container-fluid">
  <app-header titleText="JOBS" i18n-titleText progressBarState="job"></app-header>

  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/project_management_circle.png" alt="Job Icon" class="card-icon" />
      <h5 i18n>Job List</h5>

      <form class="row" (ngSubmit)="refreshSummary()">
        <div class="col-sm-3">
          <input name="projectName" id="projectName"
                 class="form-control" placeholder="Search Projects" i18n-placeholder
                 [(ngModel)]="filter.projectName" #projectName="ngModel" />
        </div>
        <div class="col-sm-3">
          <select name="dateRange" id="dateRange"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.convertedDateRange" #dateRange="ngModel">
            <option value="undefined" i18n>Select Converted Date Range</option>
            <option value="1" i18n>Current Month</option>
            <option value="2" i18n>Current Quarter</option>
            <option value="3" i18n>Current Year</option>
            <option value="4" i18n>Prior Month</option>
            <option value="5" i18n>Prior Quarter</option>
            <option value="6" i18n>Prior Year</option>
          </select>
        </div>
        <div class="col-sm-3">
          <select name="dateRange" id="dateRange"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.startDateRange" #dateRange="ngModel">
            <option value="undefined" i18n>Select Start Date Range</option>
            <option value="1" i18n>Current Month</option>
            <option value="2" i18n>Current Quarter</option>
            <option value="3" i18n>Current Year</option>
            <option value="4" i18n>Prior Month</option>
            <option value="5" i18n>Prior Quarter</option>
            <option value="6" i18n>Prior Year</option>
          </select>
        </div>
        <div class="col-sm-3">
          <select name="salespersonId" id="salespersonId"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.salespersonId" #salespersonId="ngModel">
            <option value="" i18n>Select Salesperson</option>
            <option *ngFor="let salesperson of summary?.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
          </select>
        </div>
        <div class="col-sm-3">
          <select name="jobTypeId" id="jobTypeId"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.jobTypeId" #salespersonId="ngModel">
            <option [ngValue]="null" i18n>Select Job Type</option>
            <option *ngFor="let jobType of summary?.jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
          </select>
        </div>
        <div class="col-sm-3">
          <select name="statusId" id="statusId"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.statusId" #salespersonId="ngModel">
            <option [ngValue]="undefined" i18n>Select Status</option>
            <option value="1" selected i18n>Active Jobs</option>
            <option value="2" i18n>Completed Jobs</option>
            <option value="3" i18n>In Progress Jobs</option>
            <option value="4" i18n>Not Scheduled Jobs</option>
            <option value="5" i18n>Scheduled Jobs</option>
            <option value="6" i18n>Canceled Jobs</option>
            <option [ngValue]="undefined" i18n>All Statuses</option>
          </select>
        </div>
        <div class="col-sm-3">
        </div>
        <div class="col-sm-3">
          <button type="submit" class="btn btn-bidit-action" onclick="this.blur();" i18n>Apply Filter</button>
        </div>
      </form>

      <h5 i18n>Click on job name to edit job information</h5>
      <app-spinner [isRunning]="dataSource.loading$ | async"></app-spinner>

      <mat-table class="table-bidit table-striped" style="width: 100%;" [dataSource]="dataSource"
                 matSort matSortActive="projectName" matSortDirection="asc">
        <ng-container matColumnDef="projectName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Project Name</mat-header-cell>
          <mat-cell *matCellDef="let job">
            <a routerLink="/job/{{job.quote_ID}}">
              {{job.quote_Name}}
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="projectNbr">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Project Nbr</mat-header-cell>
          <mat-cell *matCellDef="let job">
            {{job.quote_ProjectNumber}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Customer</mat-header-cell>
          <mat-cell *matCellDef="let job">
            {{job.customer?.customer_BusinessName}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="bidAmount">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Bid Amount</mat-header-cell>
          <mat-cell *matCellDef="let job">
            <ng-template [ngIf]="job.quote_BidAmount">
              ${{job.quote_BidAmount | number: '1.2-2'}}
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="jobType">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Job Type</mat-header-cell>
          <mat-cell *matCellDef="let job">
            {{job.jobType?.jobType_Desc}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="jobStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Status</mat-header-cell>
          <mat-cell *matCellDef="let job">
            {{getJobStatusName(job)}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="convertedDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Converted</mat-header-cell>
          <mat-cell *matCellDef="let job">
            {{job.quote_Converted | date:'MM/dd/yyyy'}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="startDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Start</mat-header-cell>
          <mat-cell *matCellDef="let job">
            {{job.scheduledDate | date:'MM/dd/yyyy'}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="salesperson">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Salesperson</mat-header-cell>
          <mat-cell *matCellDef="let job">
            <div>
              <div *ngFor="let quoteAssignment of job.quoteAssignments">
                {{quoteAssignment.assignedTo.firstName}} {{quoteAssignment.assignedTo.lastName}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header"></mat-header-cell>
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let job">
            <a routerLink="/job/{{job.quote_ID}}" class="btn btn-bidit-navigate" i18n>Manage</a>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator [length]="summary?.jobCount" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
    </div>
  </div>
</div>

